// Library methods
import { useContext, useMemo } from "react";

// Components
import ReportInfo from "./ReportInfo";
import PelliRobson from "../../../../components/UI/PelliRobson";
import TumblingE from "../../../../components/UI/TumblingE";
import { ReportDataContext } from "../../../../contexts/ReportDataContext";
import EyeReportContent from "../../../../components/UI/EyeReportContent";
import { ReportEachSectionContext } from "../../../../contexts/CommentContext";
import { algorithmTypes, examCardEnums } from "../../../../enums";

const EyeReport = () => {
  const { exam } = useContext(ReportDataContext);
  const { examReport } = useContext(ReportEachSectionContext);

  const examAlgorithm = useMemo(() => {
    const sectionName = examCardEnums.CONTRAST_SENSITIVITY.sectionName;
    return exam?.[sectionName]?.[0]?.algorithm;
  }, [exam]);

  if (!examReport) return null;
  // build the report content
  return (
    <div className="retinalogik-section retinalogik-report">
      {examAlgorithm === algorithmTypes.PELLI_ROBSON ? (
        <EyeReportContent
          ReportInfo={<ReportInfo />}
          ExamGraph={<PelliRobson examData={examReport} />}
        />
      ) : (
        <EyeReportContent
          ReportInfo={<ReportInfo />}
          ExamGraph={<TumblingE examData={examReport} />}
        />
      )}
    </div>
  );
};

export default EyeReport;
